import { CarFront, Phone, MapPin, ArrowUp, Mail } from "lucide-react";

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const navLinks = [
    { href: "#o-nas", label: "O nas" },
    { href: "#oferta", label: "Oferta" },
    { href: "#dlaczego-my", label: "Dlaczego my" },
    { href: "#opinie", label: "Opinie" },
    { href: "#kontakt", label: "Kontakt" },
  ];

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-slate-900 text-white" data-testid="footer">
      {/* Main Footer */}
      <div className="section-container py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Column 1 - Logo & Description */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-yellow-400 rounded-sm flex items-center justify-center">
                <CarFront className="w-7 h-7 text-slate-900" />
              </div>
              <div>
                <span className="font-heading font-bold text-xl tracking-tight block leading-tight">
                  SMRECZAK
                </span>
                <span className="text-xs text-slate-400 font-medium tracking-wide">
                  OŚRODEK SZKOLENIA KIEROWCÓW
                </span>
              </div>
            </div>
            <p className="text-slate-400 leading-relaxed max-w-md mb-6">
              Profesjonalna szkoła jazdy z wieloletnim doświadczeniem. 
              Przygotowujemy do egzaminu państwowego w MORD Nowy Targ. 
              Dołącz do grona naszych zadowolonych kursantów!
            </p>
            {/* Contact Info */}
            <div className="space-y-3">
              <a
                href="tel:608490104"
                className="flex items-center gap-3 text-slate-300 hover:text-yellow-400 transition-colors"
                data-testid="footer-phone"
              >
                <Phone className="w-5 h-5 text-yellow-400" />
                <span className="font-heading font-semibold tracking-wide">608 490 104</span>
              </a>
              <a
                href="mailto:fsmreczak@interia.pl"
                className="flex items-center gap-3 text-slate-300 hover:text-yellow-400 transition-colors"
                data-testid="footer-email"
              >
                <Mail className="w-5 h-5 text-yellow-400" />
                <span>fsmreczak@interia.pl</span>
              </a>
              <div className="flex items-center gap-3 text-slate-300">
                <MapPin className="w-5 h-5 text-yellow-400" />
                <span>Niedźwiedź 300, 34-735</span>
              </div>
            </div>
          </div>

          {/* Column 2 - Quick Links */}
          <div>
            <h4 className="font-heading font-bold text-lg tracking-tight mb-6">
              NAWIGACJA
            </h4>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <button
                    onClick={() => scrollToSection(link.href)}
                    className="text-slate-400 hover:text-yellow-400 transition-colors font-medium"
                    data-testid={`footer-link-${link.href.slice(1)}`}
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3 - CTA */}
          <div>
            <h4 className="font-heading font-bold text-lg tracking-tight mb-6">
              ZAPISZ SIĘ
            </h4>
            <p className="text-slate-400 mb-6">
              Rozpocznij swoją przygodę z prawem jazdy. Zadzwoń lub napisz do nas!
            </p>
            <button
              onClick={() => scrollToSection("#kontakt")}
              className="btn-primary text-sm py-3 px-6 w-full"
              data-testid="footer-cta"
            >
              Skontaktuj się
            </button>
          </div>
        </div>
      </div>

      {/* Road Line Decoration */}
      <div className="border-t-4 border-dashed border-yellow-400/30" />

      {/* Bottom Bar */}
      <div className="section-container py-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-slate-500 text-sm text-center md:text-left">
            © {new Date().getFullYear()} Franciszek Smreczak - Ośrodek Szkolenia Kierowców. 
            Wszelkie prawa zastrzeżone.
          </p>
          
          {/* Back to Top */}
          <button
            onClick={scrollToTop}
            className="flex items-center gap-2 text-slate-400 hover:text-yellow-400 transition-colors group"
            data-testid="back-to-top"
          >
            <span className="text-sm font-medium">Powrót na górę</span>
            <div className="w-8 h-8 border border-slate-700 rounded-sm flex items-center justify-center group-hover:border-yellow-400 group-hover:bg-yellow-400 transition-colors">
              <ArrowUp className="w-4 h-4 group-hover:text-slate-900 transition-colors" />
            </div>
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
